module.exports = __webpack_public_path__ + "img/kernelback2.6316561a.png";